<template>
  <v-form @submit.prevent="onSubmit" ref="form">
    <v-row>
      <v-col cols="12">
        <v-text-field v-model="resource.title" outlined dense :label="i18n['page_title']"
          :class="`${arabic ? 'arFont' : 'enFont'}`" :rules="[rules.required]" />
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="resource.menu_label" outlined dense :label="i18n['menu_title']"
          :class="`${arabic ? 'arFont' : 'enFont'}`" :rules="[rules.required]" />
      </v-col>
      <v-col cols="12">
        <vue-editor v-model="resource.body" />
      </v-col>
      <v-col cols="12">
        <Field :field="imageField" :item="resource" @getUpload="getUpload" />
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="resource.contact_url" outlined dense :label="i18n['contact_link']"
          :class="`${arabic ? 'arFont' : 'enFont'}`" :rules="[rules.required, rules.url]" />
      </v-col>
      <v-col cols="12" class="pt-0" :class="`${arabic ? 'arFont' : 'enFont'}`">
        <v-btn type="submit" color="success">{{ i18n["update"] }}</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Field from '@/components/Field.vue';
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
    Field,
  },
  props: ['resource'],
  data() {
    return {
      imageField: {
        name: "image",
        type: 'upload',
        label: 'image',
        info: { en: '', ar: '' }
      },
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email'],
        url: value => /^(?:(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,})|(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}))(?:\/[^\s]*)?$/.test(value) || 'test'
      },
    }
  },
  computed: {
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar")
        return true;
    },
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit('onSubmit')
      }
    },
    getUpload(image) {
      this.resource.image = image.value
    },
    async addNewServicePage() {
      if (this.$refs.form.validate()) {
        this.loading = true
        await this.$store.dispatch('putResource', { resource: `/service-pages/${this.resource.id}`, value: this.resource })
        this.loading = false

        this.$router.push('/service-pages')
      }
    }
  },
}
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";
</style>